'use strict';

var React = require('react');
var index = require('./index-b4aa8bee.js');
require('tslib');
require('events');
require('react/jsx-runtime');
require('@emotion/react');
require('react-dom');
require('react-intl');
require('react-hook-form');

const ButtonGroup = React.forwardRef(({ InputLabelProps, id, direction, flexWrap, focused, disabled, readOnly, helperText, error, label, name, options, required, onChange, value: selectedValues, sx, multiselect, }, ref) => {
    const handleClick = (buttonValue) => {
        var _a;
        if (!buttonValue)
            return;
        if (multiselect) {
            const currentSelectedValues = Array.isArray(selectedValues)
                ? selectedValues
                : selectedValues
                    ? [selectedValues]
                    : [];
            const newSelectedValues = (_a = (currentSelectedValues.includes(buttonValue)
                ? currentSelectedValues.filter((val) => val !== buttonValue)
                : [...currentSelectedValues, buttonValue])) !== null && _a !== void 0 ? _a : [];
            onChange(newSelectedValues);
        }
        else {
            if (buttonValue !== selectedValues) {
                onChange(buttonValue);
            }
        }
    };
    const inputId = id !== null && id !== void 0 ? id : `${name}_input`;
    const labelId = `${name}_label`;
    const helperTextId = `${name}_helperText`;
    const selectedStyles = {
        backgroundColor: 'action.hover',
        borderColor: 'common.black',
    };
    return (React.createElement(index.MultiThemeProvider, null, (themeName) => (React.createElement(index.MuiFormControl, null,
        label && (React.createElement(index.InputLabel, Object.assign({}, InputLabelProps, { disabled: disabled, error: error, focused: focused, htmlFor: inputId, id: labelId, readOnly: readOnly, required: required }), label)),
        React.createElement(index.Stack, { "aria-describedby": helperTextId, "aria-labelledby": labelId, direction: direction, flexWrap: flexWrap, gap: 1, sx: Object.assign({ padding: 1, overflow: 'hidden' }, sx) }, (options || []).map((buttonItem, idx) => {
            const isDisabled = buttonItem.disabled || disabled;
            const isSelected = multiselect
                ? selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(buttonItem.value)
                : buttonItem.value === selectedValues;
            const hasErrorSelection = isSelected && error;
            return (React.createElement(index.Button, { ref: ref, key: idx, "data-testid": buttonItem.testId, disabled: isDisabled, type: "button", onClick: readOnly ? undefined : () => handleClick(buttonItem.value), variant: "default", sx: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (isSelected && Object.assign({}, selectedStyles))), (hasErrorSelection && {
                    borderColor: 'error.main',
                    color: 'error.main',
                })), (readOnly && {
                    cursor: 'default',
                    pointerEvents: 'none',
                    borderColor: 'action.readOnly',
                })), { width: '100%', minWidth: 'fit-content', overflow: 'hidden', whiteSpace: 'nowrap' }), buttonItem === null || buttonItem === void 0 ? void 0 : buttonItem.sx) }, buttonItem.label));
        })),
        React.createElement(index.FormHelperText, { "data-testid": 'helperText', id: helperTextId, error: error, required: required }, index.determineHelperText({
            themeName,
            required,
            helperText,
            multiselect,
        }))))));
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = {
    direction: { xs: 'column', md: 'row' },
    options: [],
    multiselect: false,
};

exports.default = ButtonGroup;
